import {Injectable} from '@angular/core';

export interface EntityConfig {
  type: string,
  mainMethod: string,
  methodGetId: string,
  methodSetstatus: string,
  post: string,
  idPut: string,
  titleCreate: string,
  postParam: string,
  createNew: object,
  access: keyof AccessToGuides
}

@Injectable({
  providedIn: 'root'
})
export class EntityConfigService {

  config: Record<string, EntityConfig> = {
    indexEntity: {
      type: 'index-entity',
      mainMethod: 'apiIndexGet',
      methodGetId: 'apiIndexIdGet',
      methodSetstatus: 'apiIndexSetstatusIdPut',
      post: 'apiIndexPost',
      idPut: 'apiIndexIdPut',
      titleCreate: 'Создать индекс',
      postParam: 'apiIndexPostRequest',
      createNew: {fillType: 'Number_Enter'} as IndexEntry,
      access: 'indexentity'
    },
    criterion: {
      type: 'criterion',
      mainMethod: 'apiCriterionGet',
      methodGetId: 'apiCriterionIdGet',
      methodSetstatus: 'apiCriterionSetstatusIdPut',
      post: 'apiCriterionPost',
      idPut: 'apiCriterionIdPut',
      titleCreate: 'Создать критерий',
      postParam: 'apiCriterionPostRequest',
      createNew: {} as Criterion,
      access: 'criterion'
    },
    indicators: {
      type: 'indicators',
      mainMethod: 'apiIndicatorGet',
      methodGetId: 'apiIndicatorIdGet',
      methodSetstatus: 'apiIndicatorSetstatusIdPut',
      post: 'apiIndicatorPost',
      idPut: 'apiIndicatorIdPut',
      titleCreate: 'Создать показатель',
      postParam: 'apiIndicatorPostRequest',
      createNew: {} as Indicator,
      access: 'indicator'
    },
    landmarks: {
      type: 'landmarks',
      mainMethod: 'apiLandmarkGet',
      methodGetId: 'apiLandmarkIdGet',
      methodSetstatus: 'apiLandmarkSetstatusIdPut',
      post: 'apiLandmarkPost',
      idPut: 'apiLandmarkIdPut',
      titleCreate: 'Создать целевой ориентир',
      postParam: 'apiLandmarkPostRequest',
      createNew: {} as Landmark,
      access: 'landmark'
    },
    group: {
      type: 'group',
      mainMethod: 'apiGroupGet',
      methodGetId: 'apiGroupIdGet',
      methodSetstatus: 'apiGroupSetstatusIdPut',
      post: 'apiGroupPost',
      idPut: 'apiGroupIdPut',
      titleCreate: 'Создать группу учреждений',
      postParam: 'apiGroupPostRequest',
      createNew: {} as Group,
      access: 'org_group'
    },
    organization: {
      type: 'organization',
      mainMethod: 'apiOrganizationGet',
      methodGetId: 'apiOrganizationIdGet',
      methodSetstatus: 'apiOrganizationSetstatusIdPut',
      post: 'apiOrganizationPost',
      idPut: 'apiOrganizationIdPut',
      titleCreate: 'Создать учреждение МКС',
      postParam: 'apiOrganizationPostRequest',
      createNew: {} as Organization,
      access: 'ref_organization'
    },
    facility: {
      type: 'facility',
      mainMethod: 'apiFacilityGet',
      methodGetId: 'apiFacilityIdGet',
      methodSetstatus: 'apiFacilitySetstatusIdPut',
      post: 'apiFacilityPost',
      idPut: 'apiFacilityIdPut',
      titleCreate: 'Создать объект',
      postParam: 'apiFacilityPostRequest',
      createNew: {} as Facility,
      access: 'facility'
    },
    department: {
      type: 'department',
      mainMethod: 'apiDepartmentGet',
      methodGetId: 'apiDepartmentIdGet',
      methodSetstatus: 'apiDepartmentSetstatusIdPut',
      post: 'apiDepartmentPost',
      idPut: 'apiDepartmentIdPut',
      titleCreate: 'Создать структурное подразделение МКС',
      postParam: 'apiDepartmentPostRequest',
      createNew: {} as Department,
      access: 'department'
    },
    ['index-ias']: {
      type: 'index-ias',
      mainMethod: 'apiIndexiasvalueGet',
      methodGetId: 'apiIndexiasvalueIdGet',
      methodSetstatus: 'apiIndexiasvalueSetstatusIdPut',
      post: 'apiIndexiasvaluePost',
      idPut: 'apiIndexiasvalueIdPut',
      titleCreate: 'Создать значение индекса ИАС Спорт',
      postParam: 'apiIndexiasvaluePostRequest',
      createNew: {} as IndexIasValue,
      access: 'indexiasvalue'
    },
    ['index-list-value']: {
        type: 'index-list-value',
        mainMethod: 'apiIndexlistvalueGet',
        methodGetId: 'apiIndexlistvalueIdGet',
        methodSetstatus: 'apiIndexlistvalueSetstatusIdPut',
        post: 'apiIndexlistvaluePost',
        idPut: 'apiIndexlistvalueIdPut',
        titleCreate: 'Создать значение индекса (выбор из списка)',
        postParam: 'apiIndexlistvaluePostRequest',
        createNew: {},
        access: 'indexlistvalue'
    },
    users: {
      type: 'users',
      mainMethod: 'apiUserGet',
      methodGetId: 'apiUserIdGet',
      methodSetstatus: 'apiUserSetstatusIdPut',
      post: 'apiUserPost',
      idPut: 'apiUserIdPut',
      titleCreate: 'Создать пользователя',
      postParam: 'apiUserPostRequest',
      createNew: {} as User,
      access: 'useraccount'
    },
    grade: {
      type: 'grade',
      mainMethod: 'apiGradeGet',
      methodGetId: 'apiGradeIdGet',
      methodSetstatus: 'apiGradeSetstatusIdPut',
      post: 'apiGradePost',
      idPut: 'apiGradeIdPut',
      titleCreate: 'Создать оценку',
      postParam: 'apiGradePostRequest',
      createNew: {} as Grade,
      access: 'grade'
    },
  } as const

}
